import React from 'react';
import { useNavigate } from 'react-router-dom';
import CTAButton from './CTAButton';

const ServiceCTA = ({ 
  title = "Ready to Get Started?", 
  description = "Let's discuss how we can help transform your business with our solutions.",
  buttonText = "Contact Us"
}) => {
  const navigate = useNavigate();
  
  return (
    <section className="md:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-6xl">
            {title}
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto mt-6">
            {description}
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <CTAButton variant="dark" onClick={() => navigate('/contact')}>
              {buttonText}
            </CTAButton>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceCTA;
